import React from "react";

const SvgIcnOperateAdd = props => (
  <svg
    id="icn_operate_add_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>{".icn_operate_add_svg__cls-1{fill:#4a4b4c}"}</style>
    </defs>
    <path className="icn_operate_add_svg__cls-1" d="M11 4h2v16h-2z" />
    <path
      className="icn_operate_add_svg__cls-1"
      transform="rotate(-90 12 12)"
      d="M11 4h2v16h-2z"
    />
  </svg>
);

export default SvgIcnOperateAdd;
